/* Trig.js v3 by iDev Games */

// Updated all references of `window._trig` to `window._trig`

class Trig
{
    trigs = [];
    thePos = [];
    height = 0;
    pos = 0;
    scrollDir = ["trig-scroll-down", "trig-scroll-up"];
    observer;
    constructor() {
        window._trig = this;       
    }
    trigInit() {
        window._trig.observer = new IntersectionObserver(window._trig.trigObserver);
        window._trig.trigs = document.querySelectorAll('body,.enable-trig,[data-trig]');
        window._trig.trigWindowHeight();
        window._trig.trigScroll();
    }
    trigWindowHeight(){
        window._trig.height = innerHeight;
    };
    trigScroll(){
        if (window._trig.trigs) {
            window._trig.trigs.forEach(function(element, index) {
                element.index = index;
                window._trig.observer.observe(element);
            });
        }
    }
    trigEntries(entries) {
        entries.forEach(function(entry) {
            if(window._trig.trigIntersecting(entry) == true){
                window._trig.trigPos(entry);
                window._trig.updatePos(entry.target);
            } else if(document.body == entry.target){
                if(entry.target.index == 0){
                    window._trig.trigDirection(entry);
                }
                window._trig.trigPos(entry);
                window._trig.updatePos(entry.target);
            }
        });
    }
    trigDirection(entry){
        var y = entry.boundingClientRect.y;
        if(window._trig.scrollPos){
            if(window._trig.scrollPos < y-1) {
                window._trig.scrollDir = ["trig-scroll-down", "trig-scroll-up"];
            } else if(window._trig.scrollPos > y+1) {
                window._trig.scrollDir = ["trig-scroll-up", "trig-scroll-down"];
            }
        }
        window._trig.scrollPos = y;
    }
    trigObserver(entries){
        requestAnimationFrame(function () {window._trig.trigEntries(entries) });
        window._trig.observer.disconnect();
    }
    trigIntersecting(entry) {
        if(document.body != entry.target){
            if (entry.isIntersecting) {
                entry.target.classList.add("trig");
            } else {
                entry.target.classList.remove("trig");
            }
            return true;
        }
        return false;
    }
    trigPos(entry) {
        var options = { negativeOffset: 0, offset: 0, height: 0, min: -100, max: 100 };
        Object.keys(options).forEach(function(key) {
            options[key] = window._trig.trigAttributes(entry, options, key);
        });
        var el = entry.boundingClientRect.top;
        var height = entry.boundingClientRect.height;
        if(window._trig.height > height){
            height = window._trig.height;
        }
        if(document.body == entry.target){
            var posTop = 0 - (el);
            var pos = (posTop / (height - ((window._trig.height)))) * 100;
        } else {
            if(options.negativeOffset > 0){
                var posTop = 0 - (el - ((window._trig.height / 2) + options.negativeOffset));
            } else {
                var posTop = 0 - (el - ((window._trig.height / 2) - options.offset));
            }
            var pos = (posTop / (height + options.height)) * 100;
        }
        window._trig.trigSetPos(pos, options.min, options.max, entry.target);
    }
    trigAttributes(entry, options, name){
        var dSet = entry.target.getAttribute("data-trig-"+name);
        if (dSet) {
            if(dSet.match(/^[0-9]+$/) != null){
                return parseInt(dSet);
            } else {
                return dSet;
            }
        } else {
            return options[name];
        }
    }
    trigSetPos(pos, min, max, entry) {
        if (pos >= min && pos <= max) {
            window._trig.thePos[entry.index] = pos;
        } else if (pos <= min) {
            window._trig.thePos[entry.index] = min;
        } else if (pos >= max) {
            window._trig.thePos[entry.index] = max;
        }    
    }
    trigSetBody(element){
        var bo = element;
        var cl = bo.classList;
        if(cl.contains(window._trig.scrollDir[0])){
            cl.replace(window._trig.scrollDir[0], window._trig.scrollDir[1]);
        }
        if(!cl.contains(window._trig.scrollDir[0]) && !cl.contains(window._trig.scrollDir[1])){
            cl.add("trig-scroll-up");
        }
        var split = [0,25,50,75,100];
        for (let i = 0; i < split.length; i++) {

            window._trig.trigSplit(split[i], element.index, cl);
        }
    }
    trigSplit(split, index, cl){
        var name = split;
        if(split == 0 || split == 100){ 
            window._trig.trigSplitEquals(name,split,cl,index);
        } else {   
            window._trig.trigSplitMoreThan(name,split,cl,index);
        }
    }
    trigSplitEquals(name,split,cl,index){
        if(split == 0){
            name = "top";
        } else if(split == 100) {
            name = "bottom";
        }
        if(window._trig.thePos[index] == split){
            cl.add("trig-scroll-"+name);
        } else {
            cl.remove("trig-scroll-"+name);
        }
    }
    trigSplitMoreThan(name,split,cl,index){
        if(window._trig.thePos[index] >= split){
            cl.add("trig-scroll-"+name);
        } else if(window._trig.thePos[index] < split) {
            cl.remove("trig-scroll-"+name);
        }
    }
    updatePos(element) {
        if (element.dataset.trigGlobal == "true") {
            var el = document.documentElement.style;
            var id = "-"+element.id;
        } else {
            var el = element.style;
            var id = "";
        }
        if(document.body == element){
            window._trig.trigSetBody(element);
        } else {
            if(window._trig.thePos[element.index]){
                if(element.dataset.trigVar == "true"){
                    el.setProperty('--trig'+id, window._trig.thePos[element.index] + "%");
                    el.setProperty('--trig-reverse'+id, -(window._trig.thePos[element.index]) + "%");
                }    
                if(element.dataset.trigPixels == "true"){
                    el.setProperty('--trig-px'+id, window._trig.thePos[element.index] + "px");
                    el.setProperty('--trig-px-reverse'+id, -(window._trig.thePos[element.index]) + "px");
                }    
                if(element.dataset.trigDegrees == "true"){
                    el.setProperty('--trig-deg'+id, ((window._trig.thePos[element.index] / 100) * 360) + "deg");
                    el.setProperty('--trig-deg-reverse'+id, ((-(window._trig.thePos[element.index]) / 100) * 360) + "deg"); 
                }
            }
        }
    }
}
const trig = new Trig;

window.addEventListener("scroll", trig.trigScroll, { passive: true });
window.addEventListener('resize', trig.trigWindowHeight, { passive: true });
window.addEventListener('load', trig.trigInit, { passive: true });